@for (option of optionList; track option) {
<atx-dropdown-item
  [active]="isCurrentlySelected(option)"
  (click)="onClick(option)"
>
  @if (option.icon; as icon) {
  <fa-icon class="icon" [icon]="['fas', icon]"></fa-icon>
  }
  {{ option.displayValue }}
</atx-dropdown-item>
}
